import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

const MAX_LOAD_TIME = 30000;

@Injectable({
  providedIn: 'root'
})
export class LoadingScreenService {

  private _loadingStatus$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor() {
    const timeout = timer(MAX_LOAD_TIME);
    timeout.subscribe(_ => {
      this._loadingStatus$.next(false);
    });
  }

  getLoadingStatus() {
    return this._loadingStatus$.pipe(shareReplay({ bufferSize: 1, refCount: true }));
  }

  startLoading() {
    this._loadingStatus$.next(true);
  }

  stopLoading() {
    this._loadingStatus$.next(false);
  }
}
